import { OptimizelyEvent } from './optimizely/events'
import { SnowplowEvent } from './snowplow/events'
import * as Optimizely from './optimizely/optimizely'
import * as Snowplow from './snowplow/snowplow'

export enum Tracker {
  optimizely = 'optimizely',
  snowplow = 'snowplow',
}

const eventSubscribers: Record<string, Tracker[]> = {
  'add-custom-trip-item': [Tracker.optimizely],
  'add-to-cart-tour': [Tracker.optimizely],
  'add-to-cart-accommodation': [Tracker.optimizely],
  'add-to-cart': [Tracker.optimizely, Tracker.snowplow],
  'agent-insurance-upsell-event': [Tracker.snowplow],
  'luxplus-upsell-event': [Tracker.snowplow],
  'agent-luxplus-upsell-event': [Tracker.snowplow],
  'click-tour-offer': [Tracker.optimizely],
  'client-event': [Tracker.snowplow],
  'experience-event': [Tracker.snowplow],
  'impression-event': [Tracker.snowplow],
  'log-auth': [Tracker.snowplow],
  'log-operational': [Tracker.snowplow],
  'log-registration': [Tracker.snowplow],
  'offer-page-hot-lead-event': [Tracker.snowplow],
  'purchase-click': [Tracker.optimizely],
  'purchase-tour-offer': [Tracker.optimizely],
  'save-to-trip': [Tracker.optimizely],
  'search-click-lpc-offer': [Tracker.optimizely],
  'search-click-bedbank-offer': [Tracker.optimizely],
  'search-click-flash-offer': [Tracker.optimizely],
  'search-click-cruise-offer': [Tracker.optimizely],
  'search-click-cruise-special-offer': [Tracker.optimizely],
  'search-click-cruise-non-special-offer': [Tracker.optimizely],
  'search-click-typeahead': [Tracker.optimizely],
  'search-click-typeahead-*': [Tracker.optimizely],
  'search-offer-impression': [Tracker.optimizely],
  'search-click-position': [Tracker.optimizely],
  'search-click-offer': [Tracker.optimizely],
  'search-apply-filter': [Tracker.optimizely],
  'search-result-count': [Tracker.optimizely],
  'search-event': [Tracker.snowplow],
  'signup-success': [Tracker.optimizely],
  'upgrade-package': [Tracker.optimizely],
  // tracks: accommodation, cruise, tour on homepage/vertical pages and search pages
  'click-any-offer': [Tracker.optimizely],
  checkout: [Tracker.optimizely],
  'sign-up-details': [Tracker.optimizely],
  // to track about us click from the specific USP component (FrontPageUSPComponent)
  'usp-about-us-event': [Tracker.snowplow],

  // Will be removed after experiment ends
  'signup-success-event': [Tracker.snowplow],
  'signin-success-event': [Tracker.snowplow],
  'tour-upgrade-package': [Tracker.snowplow],
  'click-tour-trending-destinations': [Tracker.snowplow],
  'click-zero-search-result-offer-nearby': [Tracker.optimizely],
  'click-zero-search-result-offer-no-nearby': [Tracker.optimizely],
  'share-offer': [Tracker.optimizely],
  'share-offer-clicked': [Tracker.optimizely],
  'page-view': [Tracker.snowplow],
  'view-all-carousel-homepage': [Tracker.snowplow],
  'view-tour-carousel-homepage': [Tracker.snowplow],
  'tour-event': [Tracker.snowplow],
  'purchase-click-au': [Tracker.optimizely],
  'insurance-purchase': [Tracker.optimizely],
  'booking-protection-purchase': [Tracker.optimizely],
  'purchase-success': [Tracker.snowplow],
  'click-broad-search-location': [Tracker.optimizely],
  'add-to-cart-with-flights': [Tracker.optimizely],
  'add-to-cart-hotel-only': [Tracker.optimizely],
  'purchase-hotel-with-flights': [Tracker.optimizely],
  'purchase-hotel-only': [Tracker.optimizely],
  'purchase-hotel': [Tracker.optimizely],
  'click-hero-finder-offer': [Tracker.optimizely],
  'interact-duration': [Tracker.optimizely],
  'add-to-cart-number-of-nights': [Tracker.optimizely],
  'purchase-flight': [Tracker.optimizely],
  'purchase-cruise-offer': [Tracker.optimizely],
  'click-search-flight-deal': [Tracker.optimizely],
  'apply-promo-code-or-gift-card': [Tracker.optimizely],
  'promotion-view': [Tracker.snowplow],
  'promotion-click': [Tracker.snowplow],
  'click-flight-search-with-recent-data': [Tracker.optimizely],

  // lere
  'click-tour-offer-page-recommendation': [Tracker.optimizely],
  'view-tour-offer-page-recommendation': [Tracker.optimizely],
  'click-graph-recommendation-on-offer-page': [Tracker.optimizely],
  'view-graph-recommendation-on-offer-page': [Tracker.optimizely],

  // trip planner
  'click-saved-tab-trip-planner': [Tracker.snowplow],
  'click-itinerary-tab-trip-planner': [Tracker.snowplow],
  'click-explore-tab-trip-planner': [Tracker.snowplow],
  'click-documents-tab-trip-planner': [Tracker.snowplow],
  'click-change-explore-location-trip-planner': [Tracker.snowplow],
  'click-explore-category-top-attractions-trip-planner': [Tracker.snowplow],
  'click-explore-category-restaurants-trip-planner': [Tracker.snowplow],
  'click-explore-category-cafes-trip-planner': [Tracker.snowplow],
  'click-explore-category-parks-trip-planner': [Tracker.snowplow],
  'click-explore-category-shopping-trip-planner': [Tracker.snowplow],
  'click-explore-category-museums-trip-planner': [Tracker.snowplow],
  'click-explore-category-bars-trip-planner': [Tracker.snowplow],
  'click-explore-category-sports-trip-planner': [Tracker.snowplow],
  'click-explore-save-trip-planner': [Tracker.snowplow],
  'click-explore-add-to-itinerary-trip-planner': [Tracker.snowplow],
  'click-explore-view-more-details-trip-planner': [Tracker.snowplow],
  'click-open-map-search': [Tracker.snowplow],
  'click-map-search-result': [Tracker.snowplow],
  'click-save-map-search-result-on-tile': [Tracker.snowplow],
  'click-save-map-search-result-in-list': [Tracker.snowplow],
  'click-typeahead-list-item': [Tracker.optimizely],
  'click-typeahead-list-item-tour': [Tracker.optimizely],
  'upload-trip-document': [Tracker.snowplow],
}

export function track(eventName: keyof typeof eventSubscribers, event: OptimizelyEvent | SnowplowEvent | undefined) {
  if (!eventSubscribers[eventName]) {
    throw new Error(`Event ${eventName} not supported`)
  }

  if (!event) {
    return
  }

  if (eventSubscribers[eventName].includes(Tracker.optimizely)) {
    Optimizely.track(event as OptimizelyEvent)
  }

  if (eventSubscribers[eventName].includes(Tracker.snowplow)) {
    Snowplow.track(event as SnowplowEvent)
  }
}

export function init(store) {
  Optimizely.init(store)
  Snowplow.init()
}

export function resetContext() {
  Snowplow.resetContext()
}
